import * as React from 'react';

import GenericCopy16 from './GenericCopy16';

export const genericCopy16 = () => <GenericCopy16 />;

export default {
    title: 'Icon/Line/GenericCopy16',
    component: GenericCopy16,
    parameters: {
        notes: "`import GenericCopy16 from 'box-ui-elements/es/icon/line/GenericCopy16';`",
    },
};
